import styled from 'styled-components';

export const EllipsisText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  display: block;
  white-space: nowrap;
`;
